import { Component } from 'react';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {actions, Control, Errors, Form} from 'forms/rrf';
import { Card, Col, Container, FormGroup, Row } from 'react-bootstrap';
import {getQuestions} from '../../../actions/about-you';
import RequiredPasswordMaskInput from '../form/elements/required-password-mask-input';
import SecurityQuestionAnswer from '../form/user/security-question-answer-input';
import ArrowButton from '../button-arrow';

class WelcomeForm extends Component {
  static renderFooter() {
    return (
      <div className="fluid text-right">
        <ArrowButton ghost={false}>
          Next
        </ArrowButton>
      </div>
    );
  }

  UNSAFE_componentWillMount() {
    const {dispatch, model} = this.props;
    dispatch(getQuestions());
    dispatch(actions.change(`${model}.invitation_token`, this.props.token));
  }

  renderHeader() {
    const {welcomeMessage} = this.props;

    return (
      <h5 className="text-center mg-bottom-20 mg-top-20">
        {welcomeMessage}
      </h5>
    );
  }

  render() {
    const {
      handleSubmit, token, model, questions
    } = this.props;

    return (
      <Container className="welcome-container">
        <Row>
          <Col md={{ span: 6, offset: 3 }}>
            <Form model={model} onSubmit={handleSubmit}>
              <Errors className="errors" model={model} show={{touched: true}}/>

              <Card>
                <Card.Header>{this.renderHeader()}</Card.Header>
                <Card.Body>
                  <Errors model={model} show={{touched: true}}/>

                  <RequiredPasswordMaskInput
                    controlId="password"
                    label="Password"
                    model=".password"
                  />

                  <RequiredPasswordMaskInput
                    controlId="confirm_password"
                    label="Confirm password"
                    model=".password_confirmation"
                  />

                  <SecurityQuestionAnswer
                    answerControlId="userSecurityAnswer1"
                    answerModel=".security_answers_attributes[0].answer"
                    questionControlId="userSecurityQuestion1"
                    questionModel={`${model}.security_answers_attributes[0].security_question_id`}
                    questions={questions.filter(question => question.attributes['list-number'] === 1)}
                  />

                  <SecurityQuestionAnswer
                    answerControlId="userSecurityAnswer2"
                    answerLabel="Security answer 2"
                    answerModel=".security_answers_attributes[1].answer"
                    answerPlaceHolder="Security answer 2"
                    questionControlId="userSecurityQuestion2"
                    questionLabel="Security question 2"
                    questionModel={`${model}.security_answers_attributes[1].security_question_id`}
                    questions={questions.filter(question => question.attributes['list-number'] === 2)}
                  />

                  <FormGroup controlId="terms_and_conditions">
                    <label>
                      <Control.checkbox model=".t_cs1" required/>
                      I agree to the programme
                      {' '}
                      <Link target="_blank" to="/content-pages/terms-conditions">
                        terms & conditions
                      </Link>
                      *
                      <Errors className="errors" model=".t_cs1" show={{touched: true}}/>
                    </label>
                  </FormGroup>

                  <FormGroup controlId="privacy_policy">
                    <label>
                      <Control.checkbox model=".t_cs2" required/>
                      I agree to the
                      {' '}
                      <Link target="_blank" to="/content-pages/privacy-policy">
                        privacy policy
                      </Link>
                      *
                      <Errors className="errors" model=".t_cs2" show={{touched: true}}/>
                    </label>
                  </FormGroup>

                  <Control model=".invitation_token" type="hidden" value={token}/>
                </Card.Body>
                <Card.Footer>{WelcomeForm.renderFooter()}</Card.Footer>
              </Card>
            </Form>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  welcome: state.deep.welcome,
  questions: state.aboutYou.questions
});

export default connect(mapStateToProps)(WelcomeForm);

